var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15035 2.85499C8.95535 2.65999 8.64035 2.65999 8.44535 2.85499L6.00035 5.29499L3.55535 2.84999C3.36035 2.65499 3.04535 2.65499 2.85035 2.84999C2.65535 3.04499 2.65535 3.35999 2.85035 3.55499L5.29535 5.99999L2.85035 8.44498C2.65535 8.63999 2.65535 8.95498 2.85035 9.14998C3.04535 9.34499 3.36035 9.34499 3.55535 9.14998L6.00035 6.70499L8.44535 9.14998C8.64035 9.34499 8.95535 9.34499 9.15035 9.14998C9.34535 8.95498 9.34535 8.63999 9.15035 8.44498L6.70535 5.99999L9.15035 3.55499C9.34035 3.36499 9.34035 3.04499 9.15035 2.85499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.360439587aeab9bbb3347e1243932ff6.svg";
export { ForwardRef as ReactComponent };